import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "processing-employee-resumes"
    }}>{`Processing employee resumes`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Businesses face many challenges when accepting uploaded documents for job applications. Resumes may come in varying formats, be unsearchable, or be too large for storage. Organizations need to standardize and ingest data into other systems for processing, so they can find what they need when they need it.`}</p>
    <p>{`Adobe Acrobat Services allows organizations to:`}</p>
    <ul>
      <li parentName="ul">{`Preview PDFs when uploaded in a UI using Adobe PDF Embed API`}</li>
      <li parentName="ul">{`Convert from other formats into PDF for consistency`}</li>
      <li parentName="ul">{`Make scanned PDFs searchable upon upload (OCR)`}</li>
      <li parentName="ul">{`Extract resume data for upload into a third-party system`}</li>
      <li parentName="ul">{`Review resumes and supporting documents such as portfolios`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A candidate applies online. The backend system converts their resume into PDF format that the candidate reviews and approves. If a portfolio is submitted, it can be previewed inline on the submission website. Instead of requiring job histories to be entered separately, information can be extracted from the uploaded resume and inserted into online form fields, saving time and improving user experience.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <p>{`In this solution, see how your organization can utilize this process:`}</p>
    <ol>
      <li parentName="ol">{`Create PDF, OCR, and Compress APIs streamline and standardize documents as PDFs`}</li>
      <li parentName="ol">{`PDF Extract API obtains data, entering it into the system`}</li>
      <li parentName="ol">{`PDF Embed API renders the PDFs on the submission page`}</li>
      <li parentName="ol">{`Data from PDF Extract API is used to auto-populate a form of job history items for user approval`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      